import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export const Hero = () => {
  const { content } = useContent();
  const h = content.hero;
  const navigate = useNavigate();

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[90vh] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-[-15%] right-[-10%] h-[520px] w-[520px] rounded-full bg-sky-500/10 blur-[130px]" />
        <div className="absolute bottom-[-20%] left-[-10%] h-[420px] w-[420px] rounded-full bg-sky-700/10 blur-[130px]" />
      </div>

      <div className="max-w-5xl mx-auto px-6 w-full">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-display font-black uppercase tracking-tighter text-6xl sm:text-7xl lg:text-8xl leading-[0.9] text-slate-100"
        >
          {h.title_pre} <span className="text-sky-400">{h.title_accent}</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-8 text-xl sm:text-2xl text-slate-300 max-w-2xl leading-snug"
        >
          {h.subtitle}
        </motion.p>

        {h.intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-5 text-base text-slate-400 max-w-xl leading-relaxed"
          >
            {h.intro}
          </motion.p>
        )}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <button
            data-testid="hero-view-work"
            onClick={() => navigate("/projects")}
            className="group inline-flex items-center gap-2 bg-sky-500 text-[#050a14] font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-sky-400 transition-colors"
          >
            {h.cta_primary}
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-contact"
            onClick={() => navigate("/about#contact")}
            className="inline-flex items-center gap-2 border border-slate-700 text-slate-200 font-semibold text-sm px-7 py-3.5 rounded-full hover:border-sky-400 hover:text-sky-400 transition-colors"
          >
            {h.cta_secondary}
          </button>
        </motion.div>
      </div>
    </section>
  );
};
